import { Link } from "react-router-dom";

/*
 * OPENAPPCART LOCKED BRAND LOGO
 * Shared across all public pages via AppShellChrome / PublicLayout.
 * Styles: Frontend/src/styles/shared-shell.css
 */

type BrandLogoProps = {
  className?: string;
};

export function BrandLogo({
  className = "",
}: BrandLogoProps) {
  return (
    <Link
      aria-label="OpenAppCart home"
      className={[
        "oac-brand-logo",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      to="/"
    >
      <img
        alt="OpenAppCart"
        className="oac-brand-logo__image"
        src="/openappcart-logo.png"
      />
    </Link>
  );
}
